function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];

  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function F() {};

      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React from "react";
import { DEFAULT_BREAKPOINT } from "./css";
import { hasOwnProperty } from "./core";

function filterValidProps(props) {
  var validations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var result = {};

  for (var propName in props) {
    var validationFn = validations[propName];
    var propValue = props[propName];

    if ((validationFn === null || validationFn === void 0 ? void 0 : validationFn(propValue)) === false) {
      continue;
    } // validationFn doesn't exist or returned true


    result[propName] = propValue;
  }

  return result;
}

export function mergeProps(props, defaultProps, inheritedProps, validations) {
  return _objectSpread(_objectSpread(_objectSpread({}, defaultProps), filterValidProps(inheritedProps, validations)), filterValidProps(props, validations));
}
export function areOptionsValid(options) {
  if (!Array.isArray(options) || options.length === 0) {
    return false;
  }

  var _iterator = _createForOfIteratorHelper(options),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var option = _step.value;

      if (!(typeof option.value === "string" && (typeof option.label === "string" && option.label.trim() !== "" || /*#__PURE__*/React.isValidElement(option.label)))) {
        return false;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return true;
}
export function areCheckboxOptionsValid(options) {
  if (!Array.isArray(options) || options.length === 0) {
    return false;
  }

  var _iterator2 = _createForOfIteratorHelper(options),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var option = _step2.value;

      if (!(typeof option.key === "string" && (typeof option.label === "string" && option.label.trim() !== "" || /*#__PURE__*/React.isValidElement(option.label)))) {
        return false;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return true;
}
export function areDropdownOptionsValid(options) {
  if (!Array.isArray(options) || options.length === 0) {
    return false;
  }

  var _iterator3 = _createForOfIteratorHelper(options),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var option = _step3.value;

      if (_typeof(option.data) !== "object" || typeof option.value !== "string") {
        return false;
      }
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  return true;
}
export function getPropsFromMap(prop, map) {
  var result = {};

  for (var bp in map) {
    var propName = bp === DEFAULT_BREAKPOINT ? prop : "".concat(prop, "-").concat(bp);
    result[propName] = String(map[bp]);
  }

  return result;
}
export function getResponsivePropMap(props, defaultProps, prop, theme) {
  var lastValue = hasOwnProperty(props, prop) ? props[prop] : defaultProps[prop];

  var result = _defineProperty({}, DEFAULT_BREAKPOINT, lastValue);

  for (var bp in theme.breakpoints) {
    var responsiveProp = "".concat(prop, "-").concat(bp);
    result[bp] = hasOwnProperty(props, responsiveProp) ? props[responsiveProp] : lastValue;
    lastValue = result[bp];
  }

  return result;
}
export function mergeResponsivePropMaps(parentMap, childMap, theme) {
  if (!parentMap) {
    return childMap;
  }

  var result = _defineProperty({}, DEFAULT_BREAKPOINT, childMap[DEFAULT_BREAKPOINT] === "transparent" ? parentMap[DEFAULT_BREAKPOINT] : childMap[DEFAULT_BREAKPOINT]);

  for (var bp in theme.breakpoints) {
    result[bp] = childMap[bp] === "transparent" ? parentMap[bp] : childMap[bp];
  }

  return result;
}